(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws-utils.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const drawsSingleton = svs.numbergames.draws.internal.getDrawsSingleton();
const productMapping = svs.numbergames.productMapping;
const _dateFns = dateFns,
  isToday = _dateFns.isToday,
  isTomorrow = _dateFns.isTomorrow,
  differenceInCalendarDays = _dateFns.differenceInCalendarDays;
const formatTime = svs.utils.date.FormatTime;
const todayOrTomorrow = date => {
  date = new Date(date);
  if (isToday(date)) {
    return 'idag';
  }
  if (isTomorrow(date)) {
    return 'imorgon';
  }
  return '';
};
const dayOfWeek = date => formatTime('EEEE', date);
const dateAndMonth = date => formatTime('d/M', date);
const daysFromNow = date => differenceInCalendarDays(new Date(date), new Date());
const sortByWeekday = (d1, d2) => new Date(d1.first).getDay() - new Date(d2.first).getDay();
const getFromToStr = arr => {
  const dates = arr.flatMap(_ref => {
    let first = _ref.first,
      last = _ref.last;
    return [first, last];
  });
  const firstDate = dateAndMonth(dateFns.min(dates));
  const lastDate = dateAndMonth(dateFns.max(dates));
  return "".concat(firstDate, " - ").concat(lastDate);
};
const getMultipleDaysStr = (drawCount, firstAndLastDrawDates) => {
  switch (drawCount) {
    case 'subscription':
      return firstAndLastDrawDates.map(_ref2 => {
        let weekday = _ref2.weekday;
        return "".concat(weekday, "ar");
      }).join(' och ');
    case '1':
      return firstAndLastDrawDates.map(_ref3 => {
        let first = _ref3.first;
        return "".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      }).join(', ');
    default:
      return "".concat(firstAndLastDrawDates.map(_ref4 => {
        let first = _ref4.first;
        return "".concat(dayOfWeek(first), "ar");
      }).join(' och '), " ").concat(getFromToStr(firstAndLastDrawDates));
  }
};
const calcLastDrawDate = (draw, drawCount) => {
  const daysBetweenDraws = productMapping.isDaily(draw.productItsId) ? 1 : 7;
  const date = new Date(draw.regCloseTime);
  date.setDate(date.getDate() + (drawCount - 1) * daysBetweenDraws);
  return date;
};
function firstDrawDate(draws) {
  const closeTimes = Object.values(draws).map(draw => new Date(draw.regCloseTime));
  return dateFns.min(closeTimes);
}
function lastDrawDate(draws) {
  let _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$drawCount = _ref5.drawCount,
    drawCount = _ref5$drawCount === void 0 ? 1 : _ref5$drawCount;
  const closeTimes = Object.values(draws).map(draw => calcLastDrawDate(draw, drawCount));
  return dateFns.max(closeTimes);
}
function drawDayLabels(draws, _ref6) {
  let drawCount = _ref6.drawCount;
  const formatFirstDrawDate = regCloseTime => {
    const dateString = formatTime('EEE d/M', regCloseTime);
    return dateString.charAt(0).toUpperCase() + dateString.slice(1);
  };
  return Object.fromEntries(Object.entries(draws).map(_ref7 => {
    let _ref8 = _slicedToArray(_ref7, 2),
      productItsId = _ref8[0],
      draw = _ref8[1];
    if (!draw) {
      return [productItsId, productMapping.getDay(productItsId)];
    }
    switch (drawCount) {
      case 'subscription':
        return [productItsId, productMapping.getDay(productItsId)];
      case '1':
        return [productItsId, formatFirstDrawDate(draw.regCloseTime)];
      default:
        return [productItsId, "".concat(formatFirstDrawDate(draw.regCloseTime), " - ").concat(formatTime('d/M', calcLastDrawDate(draw, drawCount)))];
    }
  }));
}
function drawDateText(draws, _ref9) {
  var _selectedDays$;
  let productId = _ref9.productId,
    drawCount = _ref9.drawCount,
    _ref9$selectedDays = _ref9.selectedDays,
    selectedDays = _ref9$selectedDays === void 0 ? [] : _ref9$selectedDays;
  if (!Object.values(draws).filter(draw => Boolean(draw)).length) {
    return '';
  }
  if (productMapping.isProductFamily(productId) && !selectedDays.length) {
    return '';
  }
  const futureDrawDate = productItsId => {
    const draw = {
      [productItsId]: draws[productItsId]
    };
    return {
      weekday: productMapping.getDay(productItsId),
      first: firstDrawDate(draw),
      last: lastDrawDate(draw, {
        drawCount
      })
    };
  };
  if (selectedDays.length > 1) {
    const firstAndLastDrawDates = selectedDays.map(productItsId => futureDrawDate(productItsId)).sort(sortByWeekday);
    return "Speldagar: ".concat(getMultipleDaysStr(drawCount, firstAndLastDrawDates));
  }
  const productItsId = (_selectedDays$ = selectedDays[0]) !== null && _selectedDays$ !== void 0 ? _selectedDays$ : productMapping.getProductItsId(productId);
  const _futureDrawDate = futureDrawDate(productItsId),
    first = _futureDrawDate.first,
    last = _futureDrawDate.last,
    weekday = _futureDrawDate.weekday;
  const daysToStart = daysFromNow(first);
  let prefix;
  let drawDates;
  switch (drawCount) {
    case 'subscription':
      prefix = 'Speldag';
      drawDates = "".concat(weekday, "ar");
      break;
    case '1':
      prefix = 'Speldag';
      if (daysToStart < 2) {
        drawDates = "".concat(todayOrTomorrow(first));
      } else if (daysToStart >= 7 && daysToStart < 14) {
        drawDates = "n\xE4sta ".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      } else {
        drawDates = "".concat(dayOfWeek(first), " ").concat(dateAndMonth(first));
      }
      break;
    default:
      prefix = 'Speldagar';
      if (daysToStart < 2) {
        drawDates = "".concat(todayOrTomorrow(first), " - ").concat(dateAndMonth(last));
      } else {
        drawDates = "".concat(dayOfWeek(first), "ar ").concat(dateAndMonth(first), " - ").concat(dateAndMonth(last));
      }
  }
  return "".concat(prefix, ": ").concat(drawDates);
}
function sortProductsByDrawTime(draws) {
  return Object.values(draws).sort((d1, d2) => new Date(d1.regCloseTime) - new Date(d2.regCloseTime));
}
const utilsApi = {
  firstDrawDate,
  lastDrawDate,
  drawDateText,
  drawDayLabels,
  sortProductsByDrawTime
};
Object.entries(utilsApi).forEach(_ref0 => {
  let _ref1 = _slicedToArray(_ref0, 2),
    key = _ref1[0],
    value = _ref1[1];
  svs.numbergames.draws.drawsUtils[key] = (products, options) => value(drawsSingleton.findFirstPlayableDraw(products), options);
  svs.numbergames.draws.asyncDrawsUtils[key] = async (products, options) => value(await drawsSingleton.getFirstPlayableDraw(products), options);
});

 })(window);